import React, { useState } from 'react';
import { Label } from '@nooz-optics/nooz-components-lib';
import './collectionSelector.css';
import { IBlock, ILabel } from 'utils/types/contentful';
import { formatContentfulComponentProps } from 'utils/globals';
import { useMediaQuery } from 'utils/hooks/useMediaQuery';
import clsx from 'clsx';
import { Button } from '../../UI/Elements';
import { Grid } from '../../UI/Grid/grid';
import { Link } from '../../UI/Elements/Link';
import { TextWithLine } from '../Banners/BannerText/bannerText';

export interface CollectionSelectorProps {
  title: ILabel;
  collections: IBlock;
}

export const CollectionSelectorItem = ({
  index,
  image,
  color,
  label,
  button,
  link,
  headLabel,
}) => {
  const [isHover, setIsHover] = useState(false);

  const isWindowSmallSize = useMediaQuery('lg');

  const returnHeadLabel = () => {
    const elements = [...Array(15)].map(() => 0);
    return (
      <div className='absolute w-full head-label-wrapper top-4 z-10'>
        <div className={`${isHover && 'head-label-child'} w-full`}>
          {elements.map((_, i) => (
            <Label
              {...headLabel}
              weight={i % 2 ? 'bold' : 'light'}
              text={` ${headLabel?.text} -`}
              type='span'
              color={{ classname: 'white' }}
            />
          ))}
        </div>
      </div>
    );
  };

  return (
    <div
      className='relative cursor-pointer'
      role='button'
      tabIndex={0}
      onMouseEnter={() => setIsHover(true)}
      onMouseUp={() => setIsHover(true)}
      onMouseDown={() => setIsHover(false)}
      onMouseLeave={() => setIsHover(false)}>
      <Link
        {...link}
        label={null}>
        {headLabel && returnHeadLabel()}
        <div className='relative'>
          <div
            className={`bg-${
              color?.classname
            } absolute h-full w-full transform ease-in-out duration-300 border ${
              isHover ? 'rotate-3' : ''
            } cursor-pointer`}
          />
          <div className='border over relative'>
            <img
              width='100%'
              height='100%'
              src={image?.media?.file?.url}
            />
            <div
              style={{
                '-webkit-text-stroke-width': 1,
                '-webkit-text-stroke-color': 'black',
              }}
              className='absolute px-4 left-0 w-full transform transition duration-300 delay-200 flex justify-center bottom-6 opacity-1 '>
              <Label
                {...label}
                align='text-center'
                color={{ classname: 'white' }}
                size={isWindowSmallSize ? '5xl' : '6xl'}
                weight='medium'
              />
            </div>
          </div>
        </div>
      </Link>
      <div className='w-full mt-4 flex justify-center'>
        <Button
          {...button}
          type='outlined'
          icon={null}
          color={color}
        />
      </div>
    </div>
  );
};

export const CollectionSelector: React.FC<CollectionSelectorProps> = ({
  list,
  label,
}) => {
  const isWindowSmallSize = useMediaQuery('lg');
  return (
    <>
      <TextWithLine
        label={{
          ...label,
          size: isWindowSmallSize ? '4xl' : '6xl',
          color: { classname: 'gray-800' },
        }}
      />
      <div className='md:hidden w-full'>
        <Grid
          grid={{
            itemsWidth:
              'min-w-8/12 md:w-1/2 md:min-w-5/12 xl:w-1/3 xl:min-w-1/3',
            isSlider: 'block',
            itemsGrow: true,
            gridItems: list.items.map((item) => ({
              path: 'Marketing.CollectionSelectorItem',
              items: item.items,
            })),
          }}
        />
      </div>
      <ul className={clsx('grid-cols-1 gap-6 hidden md:grid md:grid-cols-3')}>
        {list.items.map((item) => (
          <CollectionSelectorItem {...formatContentfulComponentProps(item)} />
        ))}
      </ul>
    </>
  );
};
